import React, { useEffect, useMemo } from "react";
import "./InventoryKPI.scss";
import WidgetError from "../../WidgetError/WidgetError";
import { Loader, SkeletonLoader, formatNumber } from "@SeemplicityDev/shared";
import EntityList, {
  EntityItem,
} from "../../../../Components/EntityLogo/EntityList";

export interface InventoryKPIProps {
  data?: EntityItem[] | null;
  loading?: boolean;
  error?: unknown;
  refetch?: (() => void) | null;
  tooltip?: (entity: EntityItem) => string;
  tooltipCallback?: (entity: EntityItem) => string;
  onEntityClick?: (entity: EntityItem) => void;
  isForExport?: boolean;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const InventoryKPI: React.FC<InventoryKPIProps> = ({
  data,
  loading,
  error,
  refetch,
  tooltip,
  tooltipCallback,
  onEntityClick,
  isForExport,
  setIsReadyToExport,
}) => {
  const totalCount = useMemo(
    () => data?.reduce((sum, current) => (sum += current?.count ?? 0), 0),
    [data]
  );

  useEffect(() => {
    setIsReadyToExport?.(totalCount !== null);
  }, [totalCount, setIsReadyToExport]);

  useEffect(() => {
    if (!!error) {
      setIsReadyToExport?.(true);
    }
  }, [error]);

  useEffect(() => {
    setIsReadyToExport?.(!loading);
  }, [loading]);

  return (
    <div className={"inventory-kpi"}>
      {!!error ? (
        <WidgetError onWidgetsReload={refetch} />
      ) : loading || !data ? (
        <>
          <SkeletonLoader height={"42px"} width={"50%"} />
          <SkeletonLoader height={"30px"} width={"70%"} />
        </>
      ) : !!data?.length ? (
        <>
          <span className="total-count">{formatNumber(totalCount)}</span>
          <EntityList
            tooltip={tooltipCallback || tooltip}
            list={data}
            onEntityClick={onEntityClick}
            maxToDisplay={!isForExport ? 6 : null}
            showTitles
          />
        </>
      ) : (
        <Loader
          data-testid={"kpi-no-data"}
          className={"empty-state-no-match-to-filter"}
          center
          noBackground
          icon={"seem-icon-manualfinding"}
          subtitle={"There is no data for this Scope and Filter"}
        />
      )}
    </div>
  );
};

export default InventoryKPI;
